<div class="ttmodal" id="favouriteWindow">
  <div id="favouriteWindowHeader" class="ttmodal__header" >
    <span class="ttmodal__title">Create My Favourite</span>
    <div class="panel__header__button-container" id="closeButton">
      <a class="button waves-effect" (click)="onCloseClick()">
              <i class="material-icons button__icon">cancel</i>
              <span class="button__text">Close</span>
          </a>
    </div>
  </div>

  <div class="ttmodal__body">
    <div>

      <div class="input-container">
        <mat-checkbox [checked] ="SetDefault" class="example-margin"  (change)="changeCheckbox()">Set as Default</mat-checkbox>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Name of Favourite</span>
        <mat-form-field style="width:380px">
          <input matInput type="text" [(ngModel)]="favName" #favName_="ngModel" class="get-Input">
        </mat-form-field>
      </div>



      <div class="input-container">
        <span class="label" style="width: 190px;">Form Categories to Include</span>
        <mat-select placeholder="Select Category" multiple style="width: 345px" [(ngModel)]="selectedCategory"
        (selectionChange)="LoadForms()">
          <mat-option [value]="cat.Id" *ngFor="let cat of formCatList">
            {{cat.Name}}
        </mat-option>
        </mat-select>            
      </div>
      
      <div class="input-container">
        <span class="label" style="width: 190px;">Customers to Include</span>
        <mat-select placeholder="Select Customers"  multiple style="width: 345px" [(ngModel)]="selectedCustomer"  (selectionChange)="loadJobsitesForCustomer();loadFamiliesForCustomer()">
          <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
            {{customer.Name}}
        </mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">JobSites to Include</span>
        <mat-select placeholder="Select JobSite"  multiple style="width: 345px" (selectionChange)="loadEquipmentForJobsite()" [(ngModel)]="selectedJobsite">
          <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
            {{jobsite.Name}}
        </mat-option>
        </mat-select>    
      </div>


      <div class="input-container">
        <span class="label" style="width: 190px;">Families to Include</span>
        <mat-select placeholder="Select Families"  multiple style="width: 345px" [(ngModel)]="selectedFamily" (selectionChange)="loadModelList()">
          <mat-option [value]="type.Id" *ngFor="let type of  familyList">
            {{type.Name}}
        </mat-option>
        </mat-select>
      </div>

      
      <div class="input-container">
        <span class="label" style="width: 190px;">Models to Include</span>
        <mat-select placeholder="Select Models"  multiple style="width: 345px" [(ngModel)]="selectedModel">
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
        </mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Machines to Include</span>
        <mat-select placeholder="Select Machines"  multiple style="width: 345px"  [(ngModel)]="selectedEquipment" >
          <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
             {{equipment.UnitNumber}} ||{{equipment.SerialNumber}} 
        </mat-option>
        </mat-select>
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Forms to Include</span>
        <mat-select placeholder="Select Forms"  multiple style="width: 345px" [(ngModel)]="selectedForms">
          <mat-option [value]="form.Id" *ngFor="let form of formList">
            {{form.Name}}
        </mat-option>
        </mat-select>     
      </div>

      <div class="input-container">
        <span class="label" style="width: 190px;">Inspectors to Include</span>
        <mat-select placeholder="Select Inspector"  multiple style="width: 345px"  [(ngModel)]="selectedInspectors">
          <mat-option [value]="inspector.Id" *ngFor="let inspector of inspectorList">
            {{inspector.Name}}
        </mat-option>
        </mat-select>
      </div>
 

      <div class="input-container">
        <span class="label" style="width: 190px;">Status to Include</span>
        <mat-select placeholder="Select Status"  multiple style="width: 345px" [(ngModel)]="selectedStatus">
          <mat-option [value]="1">Not Started </mat-option>
          <mat-option [value]="2">In Progress </mat-option>
          <mat-option [value]="3">In Review </mat-option>
          <mat-option [value]="4">Completed </mat-option>
        </mat-select>
      </div>

    

      <div class="input-container">
        <span class="label" style="width: 190px;">Date Range to Include</span>
        <mat-select placeholder="Select Date Range"  style="width: 345px" [(ngModel)]="selectedDateRange_"  (selectionChange)="ChangeCustomeDateType($event.value)">
        <mat-option [value]="range.Id" *ngFor="let range of dateRangetypes">
          {{range.Name}}
      </mat-option>
        </mat-select>
        
        <div class="flex-container column" style="margin-left: 5%;">
          <span  *ngIf="favId"class="label" style="width: 190px; cursor: pointer;">Save Updates</span>
        <img *ngIf="favId"Class="flex-item" src="Content\Images\Icons\Edit.png" style="width: 75px" (click)="UpdateFavourite()" >
        <span *ngIf="!favId" class="label" style="width: 190px;margin-left:9%; cursor: pointer;">Save</span>
        <img  *ngIf="!favId" class="flex-item" src="Content\Images\Icons\Save.png" style="width:75px;" (click)="SaveFavouriteDigitalFormSearch()">
      </div>
      </div>

      <!-- <div class="flex-container column" style="margin-left: 75%;">
          <span  *ngIf="favId"class="label" style="width: 190px; cursor: pointer;">Save Updates</span>
        <img *ngIf="favId"Class="flex-item" src="Content\Images\Icons\Edit.png" style="width: 75px" (click)="UpdateFavourite()" >
        <span *ngIf="!favId" class="label" style="width: 190px;margin-left:9%; cursor: pointer;">Save</span>
        <img  *ngIf="!favId" class="flex-item" src="Content\Images\Icons\Save.png" style="width:75px;" (click)="SaveFavouriteDigitalFormSearch()">
      </div> -->
      

    </div>
  </div>
</div>